import { PureComponent, ReactNode } from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../store/reducers';
import { Actions } from '../store/actions';
import { Events, HPR_HFR_ONBOARDING, ON_HFR_CREATED_SUCCESSFULLY } from '../bridge/events/types';
import { track } from '../tracking';
import { EKA_EVENT, dispatch } from '../bridge/events/dispatch';
import { connect } from 'react-redux';
import { isApp } from '../bridge/methods';

const REGISTER_ABHA_CONTAINER = 'register-abha-flow';

type Props = {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
};

class RegisterABDM extends PureComponent<Props> {
    onEkaEvents: EventListener = async (event: any) => {
        const { detail } = event as CustomEvent<Events>;
        track('ABDM_CREATED_EVENT_RECEIVED', { detail: JSON.stringify(detail) });
        switch (detail.type) {
            case ON_HFR_CREATED_SUCCESSFULLY:
                track('ABDM_HFR_CREATED_EVENT_RECEIVED');
                if (!isApp()) {
                    window.parent.location.href =
                        window.parent.location.origin + '/app/patients/clinic/';
                }
                break;
        }
    };

    componentDidMount() {
        setTimeout(() => {
            this.registerNow();
        }, 1000);
        window.addEventListener(EKA_EVENT, this.onEkaEvents);
    }

    componentWillUnmount() {
        window.removeEventListener(EKA_EVENT, this.onEkaEvents);
    }

    registerNow = () => {
        track('REGISTER_NOW_ABDM');
        // dispatch({ type: HPR_HFR_ONBOARDING });
        window.hprHfrOnboarding({ containerId: REGISTER_ABHA_CONTAINER });
    };

    render(): ReactNode {
        return <div id={REGISTER_ABHA_CONTAINER}></div>;
    }
}

export default connect()(RegisterABDM);
